import { parseInstant } from '@rad/utility/parsers';
import { getJson, postJson, putJson, withDone, withOptional, withMap } from '@rad/utility/http';
export const getParcels = getJson('/api/parcel');
export const getParcel = (id) => withOptional(withMap(getJson(`/api/parcel/${id}`), (x) => ({ 'parcel': Object.assign(Object.assign({}, x.parcel), { 'created': parseInstant(x.parcel.created) }), 'propertyId': x.propertyId })));
export const findNearbyParcels = (point) => withDone(getJson(`/api/parcel/nearby/${point[0]}/${point[1]}`));
export const createParcel = (create) => withDone(postJson('/api/parcel', create));
export const updateParcel = (update) => withDone(putJson('/api/parcel', update));
